(function () {
    'use strict';

    var component = {
        transclude: true,
        templateUrl: 'app/js/components/payment-providers-settings/settings-provider-navigation-component/settings-provider-navigation.html' + itero.linkVersion,
        controller: controller,
        controllerAs: "vmSPN",
        bindings: {
            provider: '<',
            paymentProviderExternalId: '<',
            linkVersion: '<'
        }
    };

    iteroComponents.component('settingsProviderNavigation', component);

    controller.$inject = ['$location'];

    function controller($location) {
        var vm = this;

        vm.pathContains = function (name) {
            var path = $location.path();
            // this is the lazy-man's approach
            var result = path.indexOf(name) !== -1;
            return result;
        };

        vm.isValidProvider = function () {
            var restrictedProviders = ['InvoicePayment','PayEx', 'PayExInvoiceService', 'FarPay', 'AmazonPay','SwanOnAccount', 'Riverty']; //TODO:Riverty(IT-12772 chargebacks handling): to review
            return !restrictedProviders.includes(vm.provider);
        };
    }
})();
